import React from 'react';
import { useTranslation } from 'react-i18next';
import SelectInput from './SelectInput';
import { filterClasses } from '../../../styles/tailwindClassnames';

export type SortOption = {
  label: string;
  value: string;
};

type SortByDropdownProps = {
  options: SortOption[];
  ordering: string;
  onChangeSortBy: (selected: SortOption) => void;
  // Width classes; a fixed width unless the row shares its space out.
  widthClassName?: string;
};

const SortByDropdown = ({
  options,
  ordering,
  onChangeSortBy,
  widthClassName = 'w-48 flex-shrink-0',
}: SortByDropdownProps) => {
  const { t } = useTranslation();

  // ordering comes from persisted filter state — fall back to the first
  // option if it holds a value this dropdown doesn't offer.
  const selected = options.find((opt) => opt.value === ordering) || options[0];

  return (
    <div
      className={`mb-2 flex flex-col gap-1 ${widthClassName}`}
      data-testid="SortByDropdown-container"
    >
      <span className={filterClasses.label}>{t('Sort By')}</span>
      <SelectInput
        name="ordering"
        options={options}
        value={selected}
        onChange={onChangeSortBy}
        isMulti={false}
        isClearable={false}
        isSearchable={false}
        isDisabled={false}
        isLoading={false}
        className=""
        variant="routeFilter"
      />
    </div>
  );
};

export default SortByDropdown;
